import { loadStripe } from '@stripe/stripe-js';

import { Location } from '@/types';

export const getStripeToken = (scanLocation: Location) => {
  const paymentToken = scanLocation.payments?.find(
    ({ paymentType }) => paymentType === 'stripe',
  )?.paymentToken;
  return paymentToken && loadStripe(paymentToken);
};

export const getAffirmPaymentType = (scanLocation: Location) => {
  return scanLocation?.payments?.find(({ paymentType }) => paymentType === 'affirm');
};
